import React from 'react';
import { Hero } from '../components/Hero';
import { FeaturedPodcast } from '../components/FeaturedPodcast';
import { ArticleGrid } from '../components/ArticleGrid';
import { FieldNotes } from '../components/FieldNotes';
import { PodcastList } from '../components/PodcastList';
import { Newsletter } from '../components/Newsletter';
export function Home() {
  return <>
      <Hero data-id="element-225" />
      <FeaturedPodcast data-id="element-226" />
      <ArticleGrid data-id="element-227" />
      <FieldNotes data-id="element-228" />
      <PodcastList data-id="element-229" />
      <Newsletter data-id="element-230" />
    </>;
}